import React from "react";

import closeIcon from "../../../assets/img/icons/closeIcon.svg";
import { useSiteData } from "../../../SiteDataContext";

const Modal: React.FC = () => {
  const { siteData, setSiteData } = useSiteData();

  const close = (): void => {
    setSiteData({ ...siteData, isOpenPolicyModal: false });
  };

  const handleBackgroundClick = (e: React.MouseEvent<HTMLDivElement>): void => {
    if ((e.target as HTMLElement).id === "policy-modal") {
      close();
    }
  };

  return (
    <div
      id="policy-modal"
      role="dialog"
      aria-label="Privacy policy"
      className={`modal-container p-5 md:p-2 flex justify-center items-center ${
        siteData.isOpenPolicyModal ? "" : "hidden"
      }`}
      onClick={handleBackgroundClick}
    >
      <div className="overflow-auto relative w-100p h-100p md:mh-65-5 md:mw-60 bg-cream pl-1-25 br-1-25 md:plr-4-75">
        <h2 className="text-center f-size-2 font-bold mt-8 mb-3 ">
          {siteData?.policy?.title}
        </h2>

        <div
          role="button"
          aria-label="Close"
          className="inline absolute right-8 top-8 p-0-5 cursor-pointer"
          onClick={close}
        >
          <img className="w-1-125" src={closeIcon} alt="" />
        </div>

        <article className="f-size-1">
          <div
            className="ck-content"
            dangerouslySetInnerHTML={{
              __html: siteData?.policy?.content || "",
            }}
          />
        </article>
      </div>
    </div>
  );
};

export default Modal;
